import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TimecardRow } from "../../models/timecardrow";
import { Converters } from "../../helpers/converters";
import { APIService } from '../api.service';
import { ApiTemplate } from '../../models/apiTemplate';
import { ReturnObject } from '../../models/returnObject';

@Injectable()
export class TemplateService {

    constructor(private api: APIService) {}

    getTemplates(email: string): Observable<ReturnObject<ApiTemplate[]>> {
        return this.api.getAPI(`template/${email.toUpperCase()}`);
    }

    getTemplate(email: string, templateName: string, weekNo: string): Observable<ReturnObject<ApiTemplate[]>> {
        return this.api.getAPI(`template/${email.toUpperCase()}/${encodeURIComponent(templateName)}/${weekNo}`);
    }

    saveTemplate(email: string, templateName: string, timecardRows: TimecardRow[]): Observable<ReturnObject<ApiTemplate[]>> {
        let templates: ApiTemplate[] = Converters.TimeCardRowToApiTemplate(email, templateName, timecardRows);
        return this.api.postAPI(`template`, templates[0].templateList);
    }

    deleteTemplate(email: string, templateName: string): Observable<ReturnObject<ApiTemplate[]>> {
        return this.api.deleteByEnpointApi(`template/${email.toUpperCase()}/${encodeURIComponent(templateName)}`);
   }
}
